import {
    ApplicationRef,
    ComponentFactory,
    ComponentFactoryResolver,
    ComponentRef,
    EmbeddedViewRef,
    Injectable,
    Injector
} from '@angular/core';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { BaseSandbox } from '@mediahaven/shared';
import { ApiRecordType, FragmentId, GenerateGuid, MediaObjectId, ShItemUploadComponent } from '@stylehaven/components';
import { UploadSandboxService } from './upload.sandbox.service';

@Injectable({ providedIn: 'root' })
export class UploadHelper extends BaseSandbox {
    private componentRef: ComponentRef<ShItemUploadComponent>;

    constructor(
        private readonly componentFactoryResolver: ComponentFactoryResolver,
        private readonly appRef: ApplicationRef,
        private readonly injector: Injector,
        private readonly uploadService: UploadSandboxService
    ) {
        super();
    }

    public askUserForFiles(multiFileSelect = true): Observable<FileList> {
        if (this.componentRef) {
            // old componentRef still active
            this.removeFromDom(this.componentRef);
        }

        const componentFactory: ComponentFactory<ShItemUploadComponent> =
            this.componentFactoryResolver.resolveComponentFactory(ShItemUploadComponent);

        this.componentRef = componentFactory.create(this.injector);
        this.appRef.attachView(this.componentRef.hostView);

        const domElem: HTMLElement = (this.componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
        document.body.appendChild(domElem);

        this.componentRef.instance.multiFileSelect = multiFileSelect;

        const fileList$: Observable<FileList> = this.componentRef.instance.selection.pipe(
            tap(() => this.removeFromDom(this.componentRef))
        );

        this.componentRef.instance.click();

        return fileList$;
    }

    private removeFromDom(componentRef: ComponentRef<ShItemUploadComponent>): void {
        this.appRef.detachView(componentRef.hostView);
        componentRef.destroy();
    }

    public uploadFiles(
        files: FileList,
        parentRecordId: MediaObjectId,
        zoneId: string,
        recordType: ApiRecordType
    ): Observable<boolean> {
        return this.uploadService.uploadFiles(files, zoneId, parentRecordId, recordType, GenerateGuid());
    }

    public uploadNewOriginal(file: File, fragmentId: FragmentId): Observable<boolean> {
        return this.uploadService.uploadNewOriginal(file, fragmentId);
    }
}
